<template>
    <div class="modal" v-show="show">
        <div class="modal__container">
            <a @click.prevent="close" class="modal__close">&times;</a>
            <slot name="header" class="modal__title"></slot>
            <slot name="body" class="modal__body"></slot>
            <slot name="footer" class="modal__footer"></slot>
            
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            show: {
                required: true
            }
        },
        methods: {
            close() {
                this.$emit("input", !this.show);
            }            
        },
        watch: {
            'show'(nV){
                let element = document.querySelector(".body");
                if(nV){
                    element.classList.add("block-overflow");
                }
                else{
                    element.classList.remove("block-overflow");
                }
            }
        }
    };
</script>


<style lang="scss" scoped>
    .modal {
        background-color: rgba(40,40,40, 0.7);
        box-shadow: 0 1px 5px rgba(0,0,0,.1), 0 8px 11px rgba(0,0,0,.3);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        z-index: 999;
        
        overflow: auto;
        box-sizing: border-box;
        
    }
    .modal.modal-lg{
        .modal__container{
            width: 100%;
            max-width: 1200px;
        }
    }
    .modal__container{
        border-radius: 3px;
        background: #fff;
        width: 600px;
        position: relative;
        padding: 30px;
        height: fit-content;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .modal__close{
        position: absolute;
        top: 0px;
        right: 6px;
        cursor: pointer;
        font-size: 1.25em;
        padding: 2px;
    }
</style>